import { AUTOPILOT_COLORS, autopilotInsetCardStyle } from "../../../components/autopilot/styles";

// Objetos de estilo do drawer de Detalhe (H3, PO1-2620) — mesmo espírito de
// SectionCard/autopilot styles.js: objetos exportados, não CSS novo. O padrão
// visual (painel lateral dentro do grid da própria página, cabeçalho com botão
// fechar, seções internas) replica o de ConferenciaFatura's conf-fatura-drawer,
// mas como componente novo — ver justificativa na spec (Confluence PO1-2620).

export const drawerShellStyle = {
  ...autopilotInsetCardStyle,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  overflow: "hidden",
};

export const drawerHeadStyle = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "0.75rem",
  padding: "1rem 1.1rem 0.75rem",
  borderBottom: `1px solid ${AUTOPILOT_COLORS.border}`,
};

export const drawerEyebrowStyle = {
  color: AUTOPILOT_COLORS.accent,
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  marginBottom: "0.2rem",
};

export const drawerTitleStyle = {
  color: AUTOPILOT_COLORS.title,
  fontSize: "1.02rem",
  fontWeight: 700,
};

export const drawerSubtitleStyle = {
  color: AUTOPILOT_COLORS.muted,
  fontSize: "0.78rem",
  marginTop: "0.15rem",
};

export const drawerCloseButtonStyle = {
  background: "transparent",
  border: "none",
  color: AUTOPILOT_COLORS.muted,
  fontSize: "1.1rem",
  lineHeight: 1,
  cursor: "pointer",
  padding: "0.2rem 0.4rem",
};

export const drawerBodyStyle = {
  padding: "0.9rem 1.1rem 1.1rem",
  overflowY: "auto",
  flex: 1,
  minHeight: 0,
};

export const drawerTabsStyle = {
  padding: "0 1.1rem",
  borderBottom: `1px solid ${AUTOPILOT_COLORS.border}`,
};

export const drawerFieldRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0.5rem 0",
  borderBottom: `1px solid ${AUTOPILOT_COLORS.borderFaint}`,
  fontSize: "0.85rem",
};

export const drawerFieldLabelStyle = {
  color: AUTOPILOT_COLORS.muted,
};

export const drawerFieldValueStyle = {
  color: AUTOPILOT_COLORS.text,
  textAlign: "right",
};

export const drawerEmptyStyle = {
  color: AUTOPILOT_COLORS.muted,
  fontSize: "0.85rem",
  padding: "1.25rem 0",
  textAlign: "center",
};
